'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocalStorage = exports.redirectToLogin = undefined;

var _urls = require('./urls');

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getOrigin() {
  return window.location.origin;
}

function getPathName() {
  return window.location.pathname;
}

function redirectToLogin() {
  var origin = getOrigin();
  var path = getPathName();
  window.location.href = '' + origin + _urls2.default.login + '?target=' + path;
}

function getLocalStorage() {
  return window.localStorage;
}

exports.redirectToLogin = redirectToLogin;
exports.getLocalStorage = getLocalStorage;